import { createContext } from 'react';

export interface FavoritosContextValue {
    favoritos: string[];
    esFavorito: (href: string) => boolean;
    toggleFavorito: (href: string) => void;
}

const FavoritosContext = createContext<FavoritosContextValue>({
    favoritos: [],
    esFavorito: () => false,
    toggleFavorito: () => {},
});

export default FavoritosContext;
